export default __webpack_public_path__ + "fonts/kingvision.27dc26ab3ac3a6ffb1fee7a67ae420fd.png";